import { authorizedFetch } from "./base";

export type ReferralEntryStatus = "registered" | "in_trial" | "subscribed";

export interface ReferralEntry {
  id: number;
  referred_at: string;
  status: ReferralEntryStatus;
  email: string;
}

export interface ReferralStatus {
  referral_code: string;
  months_earned: number;
  referrals: ReferralEntry[];
}

export async function getReferralStatus(): Promise<ReferralStatus> {
  return authorizedFetch<ReferralStatus>("/referrals");
}
